/*
 *
 * NotificationContainer reducer
 *
 */

import { fromJS } from "immutable"
import {
  DEFAULT_ACTION,
  UPDATE_BADGE,
  FETCH_NOTIFICATIONS,
  FETCH_NOTIFICATIONS_SUCCESS,
  GO_TO_NOTIFICATION_SUCCESS,
  SET_ALL_READ,
  SET_ALL_READ_SUCCESS,
  SET_COUNT,
} from "./constants"

export const initialState = fromJS({
  count: 0,
  notifications: [],
  total: 0,
  isLoading: false,
})

function notificationContainerReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_BADGE:
      return state.set("count", action.payload)
    case FETCH_NOTIFICATIONS:
      return state.set("isLoading", true)
    case FETCH_NOTIFICATIONS_SUCCESS:
      return state
        .set("isLoading", false)
        .set("notifications", action.payload.notifications)
        .set("total", action.payload.total)

    case GO_TO_NOTIFICATION_SUCCESS:
      const notifications = JSON.parse(
        JSON.stringify(state.get("notifications"))
      )

      notifications.forEach((item, index) => {
        if (action.payload.id == item.id) {
          notifications[index] = action.payload
        }
      })

      return state.set("notifications", notifications)
      break

    case SET_ALL_READ:
      return state.set("isLoading", true)
    case SET_ALL_READ_SUCCESS:
      const newnotifications = JSON.parse(
        JSON.stringify(state.get("notifications"))
      )

      newnotifications.forEach((item, index) => {
        newnotifications[index].visited = true
      })

      return state
        .set("count", 0)
        .set("notifications", newnotifications)
        .set("isLoading", false)

    case SET_COUNT:
      return state.set("count", 0)

    default:
      return state
  }
}

export default notificationContainerReducer
